import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import CultivationUnitList from './CultivationUnitList';

const CultivationUnits = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Derechos de Agua', icon: 'icon-droplets' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Unidades de Cultivo' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<CultivationUnitList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default CultivationUnits;
